<div class="sidebar">
  <div class="profile-section">
    <div class="profile-bg"></div>
    <div class="profile-image-container">
      <img
        [src]="
          userProfile?.profile
            ? userProfile?.profile
            : '../../../assets/default-doctor.webp'
        "
        alt="Doctor Profile"
        class="profile-image"
      />

      <span class="online-indicator"></span>
    </div>

    <div class="doctor-info">
      <h2>{{ userProfile.first_name + " " + userProfile.last_name }}</h2>
    </div>
    <label class="switch">
      <input type="checkbox" checked />
      <span class="slider"></span>
    </label>
  </div>
  <div class="sidebar-menu">
    <div
      class="menu-item"
      [ngClass]="{ active: commonService.activeTab === 'dashboard' }"
      (click)="setActiveTab('dashboard')"
    >
      <img
        class="iconsnavigation side-bar-img"
        src="../../../assets/home-button.webp"
        alt=""
      />
      <span class="sidebar_item">Dashboard</span>
    </div>

    <div
      class="menu-item"
      [ngClass]="{ active: commonService.activeTab === 'notes' }"
      (click)="setActiveTab('notes')"
    >
      <img
        class="iconsnavigation side-bar-img"
        src="../../../assets/pencil.webp"
        alt=""
      />
      <span class="sidebar_item">Consultation History</span>
    </div>

    <div
      class="menu-item"
      [ngClass]="{ active: commonService.activeTab === 'missed' }"
      (click)="setActiveTab('missed')"
    >
      <img
        class="iconsnavigation side-bar-img"
        src="../../../assets/missed-icons/missed-request.webp"
        alt=""
      />
      <span class="sidebar_item">Missed Requests</span>
    </div>

    <div
      class="menu-item"
      [ngClass]="{ active: commonService.activeTab === 'incomplete' }"
      (click)="setActiveTab('incomplete')"
    >
      <img
        class="iconsnavigation side-bar-img"
        src="../../../assets/missed-icons/incomplete.webp"
        alt=""
      />
      <span class="sidebar_item">Incompelete Requests</span>
    </div>

    <div
      class="menu-item"
      [ngClass]="{ active: commonService.activeTab === 'user-profile' }"
      (click)="setActiveTab('user-profile')"
    >
      <img
        class="iconsnavigation side-bar-img"
        src="../../../assets/missed-icons/profile-setting.webp"
        alt=""
      />
      <span class="sidebar_item">Profile Settings</span>
    </div>

    <div
      class="menu-item"
      [ngClass]="checkCallRinging()"
      [ngClass]="{ active: commonService.activeTab === 'logout' }"
      (click)="setActiveTab('logout')"
    >
      <img
        class="iconsnavigation side-bar-img"
        src="../../../assets/logout.webp"
        alt=""
      />
      <span class="sidebar_item">Logout</span>
    </div>
  </div>
</div>

<div id="contactSupportPopup" *ngIf="showPopup" class="contact-support-overlay">
  <div class="contact-support-content">
    <span class="contact-support-close" (click)="closePopup()">&times;</span>

    <div class="contact-support-header">
      <span class="phone-icon">📞</span>
      <h2>Contact Admin</h2>
    </div>

    <div class="contact-support-body">
      <div class="icon-section">
        <div class="user-icon">👤</div>
      </div>
      <div class="details-section">
        <p><strong>Name:</strong> {{ adminName }}</p>
        <p><strong>Contact Number(s):</strong></p>
        <ul>
          <li *ngFor="let number of contactNumbers">{{ number }}</li>
        </ul>
        <p><strong>Email ID:</strong> {{ adminEmail }}</p>
      </div>
    </div>
  </div>
</div>

<div class="popup-overlay" *ngIf="showLogoutModal">
  <div class="logout-popup">
    <div class="logout-icon">
      <img
        class="logout-img"
        src="../../../assets/doctor-logout.png"
        alt="logout"
      />
    </div>
    <h3>Confirm Logout</h3>
    <p>Are you sure you want to logout?</p>
    <div class="popup-buttons">
      <button class="logout-btn" (click)="confirmLogout()">Logout</button>
      <button class="cancel-btn" (click)="cancelLogout()">Cancel</button>
    </div>
  </div>
</div>
